import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=75fbd421&scoped=true&"
var script = {}
import style0 from "./feedback.vue?vue&type=style&index=0&id=75fbd421&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbd421",
  null
  
)

export default component.exports